<template>
  <main-layout
    customControls
    controlsBg="light"
    :hasControlsBar="false"
    :breadcrumb="getBreadcrumb"
  >


      <template >
        <grid-row class="margin-top-xl" column-align="center">
          <grid-col col-size="12">
            <div style="display: flex; align-items: center; justify-content: space-between;">
              <h1 class="header-title">
                <chevron @click="$router.push({name: 'NutritionalPlanTemplateList'})" />
                {{ mode === 'create' ? $t('health.nutritionalPlanTemplate.new') : $t('health.nutritionalPlanTemplate.edit') }}
              </h1>
              <div style="display: flex; gap: 0.5em;">
                <button class="update-plan-btn" @click="updatePlan">
                  {{ $t('health.nutritionalPlanTemplate.saveTemplate') }}
                </button>
              </div>
            </div>
          </grid-col>
        </grid-row>
        <template>
          <div class="form-block">
            <div class="form-row">
              <label class="form-label">{{ $t('health.patient.name') }}<span class="required">*</span></label>
              <input
                v-model="templateName"
                type="text"
                class="form-input"
                required="true"
                maxlength="255"
              />
            </div>

            <div class="form-row">
              <label class="form-label">{{ $t('health.nutritionalPlanTemplate.description') }}</label>
              <textarea
                v-model="templateDescription"
                class="form-textarea"
                maxlength="500"
              />
            </div>
          </div>
          <div class="calendar-layout">
            <recipe-detail-modal
              v-if="selectedRecipe"
              :recipe="selectedRecipe"
              @close="onRecipeModalClose"
            />
            <table class="week-table">
              <thead>
              <tr>
                <th></th>
                <th v-for="day in weekDays" :key="day"
                    :class="{ 'selected-day': selectedDaySummary && selectedDaySummary.day === day }"
                    @click="selectDay(day)"
                    style="cursor: pointer;">
                  {{ $t(`health.nutritionalPlan.weekDays.${day}`) }}
                </th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="mealType in mealTypes" :key="mealType">
                <td>{{ $t(`health.nutritionalPlan.mealTypes2.${mealType}`) }}
                  <div
                    v-if="showSummary && selectedDaySummary && selectedDaySummary.byMealType[mealType] && selectedDaySummary.byMealType[mealType].length"
                    class="macro-summary macro-summary--inline"
                  >
                    <div class="macro-summary__item">
                      <span class="macro-summary__label">P:</span>
                      <span class="macro-summary__percent" style="background: #9765E0">
        {{ mealTypeProteinPercent(selectedDaySummary.byMealType[mealType]) }}%
      </span>
                    </div>
                    <div class="macro-summary__item">
                      <span class="macro-summary__label">HC:</span>
                      <span class="macro-summary__percent" style="background: #C4CC52">
        {{ mealTypeCarbsPercent(selectedDaySummary.byMealType[mealType]) }}%
      </span>
                    </div>
                    <div class="macro-summary__item">
                      <span class="macro-summary__label">G:</span>
                      <span class="macro-summary__percent" style="background: #00C2BA">
        {{ mealTypeFatPercent(selectedDaySummary.byMealType[mealType]) }}%
      </span>
                    </div>
                  </div>
                </td>
                <td v-for="day in weekDays" :key="day">
                  <template v-for="meal in [getMealsByDayAndType(day, mealType)[0] || {}]">
                    <div :key="day + mealType + 'wrapper'" class="meal-wrapper">
                      <div v-if="meal.name" class="meal-actions">
                        <font-awesome-icon
                          :icon="icons.trash"
                          class="meal-action-icon meal-action-icon--delete"
                          @click.stop="deleteRecipe(day, mealType)"
                        />
                        <font-awesome-icon
                          :icon="icons.change"
                          class="meal-action-icon meal-action-icon--change"
                          @click.stop="changeRecipe(day, mealType)"
                        />
                      </div>
                      <img
                        v-if="meal.imageUrl"
                        :src="meal.imageUrl"
                        :alt="meal.name"
                        class="meal-image"
                        style="cursor: pointer;"
                        @click="openRecipeDetail(meal, day, mealType)"
                      />
                      <div
                        v-else-if="meal.name"
                        class="meal-image meal-image--placeholder"
                        style="cursor: pointer;"
                        @click="openRecipeDetail(meal, day, mealType)"
                      >
                        <font-awesome-icon :icon="icons.utensils" />
                      </div>


                      <div class="meal-info">
                        <h3 v-if="meal.name" class="meal-name">{{ meal.name }}</h3>
                        <div v-if="meal.items && meal.items.length" class="macros">
                          <span>P: {{ totalMacro(meal.items, 'protein') }} g</span>
                          <span>HC: {{ totalMacro(meal.items, 'carbs') }} g</span>
                          <span>G: {{ totalMacro(meal.items, 'fat') }} g</span>
                          <span> Kcal: {{ totalMacro(meal.items, 'calories') }}</span>
                        </div>

                      </div>
                    </div>
                  </template>
                </td>
              </tr>
              </tbody>
            </table>
            <div v-if="showSummary" class="summary-panel">
              <h2 class="summary-title">{{ $t('health.nutritionalPlan.summary') }}</h2>
              <ingest-macro-distribution-chart
                :ingredients="selectedDaySummary.items"
                :height="180"
                :width="180"
              />
              <div class="macro-summary">
                <div class="macro-summary__item">
                  <span class="macro-summary__label">{{ $t('health.summary.protein') }}</span>
                  <span class="macro-summary__value">{{ totalMacro(selectedDaySummary.items, 'protein') }}g</span>
                  <span class="macro-summary__percent" style="background: #9765E0">{{ summaryProteinPercent() }}%</span>

                </div>
                <div class="macro-summary__item">
                  <span class="macro-summary__label">{{ $t('health.summary.carbs') }}</span>
                  <span class="macro-summary__value">{{ totalMacro(selectedDaySummary.items, 'carbs') }}g</span>
                  <span class="macro-summary__percent" style="background: #C4CC52">{{ summaryCarbsPercent() }}%</span>
                </div>
                <div class="macro-summary__item">
                  <span class="macro-summary__label">{{ $t('health.summary.fat') }}</span>
                  <span class="macro-summary__value">{{ totalMacro(selectedDaySummary.items, 'fat') }}g</span>
                  <span class="macro-summary__percent" style="background: #00C2BA">{{ summaryFatPercent() }}%</span>
                </div>
                <div class="macro-summary__item macro-summary__item--fibre">
                  <span class="macro-summary__label">{{ $t('health.summary.fibre') }}</span>
                  <span class="macro-summary__value">{{ totalMacro(selectedDaySummary.items, 'fibre') }}g</span>
                </div>
              </div>

            </div>
          </div>

          <div class="add-food-section">
            <div class="add-food-selects">
              <select v-model="addFoodDay">
                <option value="" disabled>{{ $t('health.nutritionalPlan.selectDay') }}</option>
                <option v-for="day in weekDays" :key="day" :value="day">
                  {{ $t(`health.nutritionalPlan.weekDays.${day}`) }}
                </option>
              </select>
              <select v-model="addFoodMealType">
                <option value="" disabled>{{ $t('health.nutritionalPlan.selectMeal') }}</option>
                <option v-for="mealType in mealTypes" :key="mealType" :value="mealType">
                  {{ $t(`health.nutritionalPlan.mealTypes2.${mealType}`) }}
                </option>
              </select>
              <button class="add-food-btn" @click="openAddFoodModal">
                + {{ $t('health.nutritionalPlan.addFood') }}
              </button>
              <button class="add-food-btn" @click="openSearchRecipeModal">
                + {{ $t('health.nutritionalPlan.addRecipe') }}
              </button>

            </div>
          </div>

          <add-food-modal
            v-if="showAddFoodModal"
            :foods="availableFoods"
            v-on:input="onFoodSelected"
            v-on:close="showAddFoodModal = false"
          />

          <add-recipe-modal
            v-if="showSearchRecipeModal"
            :recipes="availablePlans"
            :initial-type="addFoodMealType"
            v-on:input="onPlanSelected"
            v-on:close="showSearchRecipeModal = false"
          />

        </template>
      </template>
  </main-layout>
</template>



<script>
import GridRow from '@/components/shared/grid/GridRow';
import GridCol from '@/components/shared/grid/GridCol';
import HealthExplorerControlsUserSelect from 'BRAND/components/explorer/HealthExplorerControlsUserSelect';
import HealthWeekControl from 'BRAND/components/explorer/HealthWeekControl';
import BtnPill from '@/components/shared/buttons/BtnPill';
import MainLayout from '@/layouts/MainLayout';
import Chevron from '@/components/shared/Chevron';
import IngestMacroDistributionChart from 'BRAND/components/nutritionPlan/IngestMacroDistributionChart';
import AddFoodModal from 'BRAND/components/nutritionPlan/AddFoodModal';
import AddRecipeModal from 'BRAND/components/nutritionPlan/AddRecipeModal';
import RecipeDetailModal from 'BRAND/components/nutritionPlan/RecipeDetailModal';
import { faTrashAlt, faSyncAlt, faExclamationTriangle, faUtensils, faRedoAlt} from '@fortawesome/pro-regular-svg-icons';
import FontAwesomeIcon from '@fortawesome/vue-fontawesome';
import recipeApi from '../../api/recipe'
import {mapGetters} from "vuex";
import nutritionalPlanApi from '../../api/nutritionalPlan'
import foodApi from '../../api/nutritionPlan'
import templateApi from '../../api/template'

export default {
  name: 'NutritionCalendarTable',
  components: {
    GridRow,
    GridCol,
    Chevron,
    HealthWeekControl,
    HealthExplorerControlsUserSelect,
    BtnPill,
    MainLayout,
    IngestMacroDistributionChart,
    AddFoodModal,
    AddRecipeModal,
    RecipeDetailModal,
    FontAwesomeIcon,
  },
  props: {
    foods: Array,
    color: String,
    name: String,
    imageUrl: String
  },
  data () {
    const weekPlan = []
    const originalAmounts = {};
    weekPlan.forEach(dayPlan => {
      dayPlan.recipes.forEach(recipe => {
        recipe.items.forEach(item => {
          const key = `${dayPlan.day}_${dayPlan.type}_${item.food_id}`;
          originalAmounts[key] = item.amount;
        });
      });
    });

    return {
      weekPlan,
      originalAmounts,
      selectedDaySummary: "monday",
      showSummary: false,
      weekDays: ['monday','tuesday','wednesday','thursday','friday','saturday','sunday'],
      mealTypes: ['Desayuno', 'Almuerzo', 'Comida', 'Merienda', 'Cena'],
      addFoodDay: '',
      addFoodMealType: '',
      showAddFoodModal: false,
      availableFoods: [],
      showNotesModal: false,
      showSearchRecipeModal: false,
      availablePlans: [],
      selectedRecipe: null,
      icons: {
        trash: faTrashAlt,
        change: faSyncAlt,
        warning: faExclamationTriangle,
        utensils: faUtensils,
        reset: faRedoAlt
      },
      originalWeekPlan: [],
      templateName:'',
      templateDescription:'',
      mode:''
    };
  },
  computed: {
    ...mapGetters([
      'getLanguageCode'
    ]),
    getBreadcrumb() {
      return [
        {link: '/workspace', name: this.$t('menu.workspace')},
        {link: '/nutritional-plan-template', name: this.$t('health.nutritionalPlanTemplate.title')},
        {link: '/nutritional-plan-template/edit', name: this.$t('health.nutritionalPlanTemplate.edit'), disabled: true}
      ];
    },

  },
  async created() {
    const language = this.getLanguageCode;

    this.availablePlans = await recipeApi.getRecipes(this, language);
    this.availableFoods = await foodApi.getFoodList(this, language);

    const templateFromRoute = this.$route.params.template;
    if (templateFromRoute) {
      this.initTemplate(templateFromRoute);
      this.mode='edit';
    }else{
      this.mode='create';
    }
  },
  methods: {
    getMealsByDayAndType(day, type) {
      if (!this.weekPlan || !this.weekPlan.length) return [];
      return this.weekPlan
        .filter(item => item.day === day && item.type === type && item.recipes && item.recipes.length > 0)
        .map(item =>  {
          const recipe = item.recipes[0] || {};
          return {
            id: recipe.id,
            name: recipe.name,
            imageUrl: recipe.imageUrl,
            isCustom: recipe.isCustom || false,
            items: item.recipes.flatMap(r => r.items),
            color: recipe.predictedScoreColor || '#000',
          };
        });
    },
    async initTemplate(template) {
      try {
        const language = this.getLanguageCode;
        const recipesWithItems = await templateApi.getTemplateRecipes(this, template.id, language);
        const newWeekPlan = [];
        if (recipesWithItems && Array.isArray(recipesWithItems)) {
          recipesWithItems.forEach(entry => {
            if (entry.recipes && entry.recipes.length > 0) {
              entry.recipes.forEach(recipe => {
                let dayEntry = newWeekPlan.find(d => d.day === entry.date && d.type === entry.type);

                const recipeObj = {
                  id: recipe.id,
                  type: entry.type,
                  name: recipe.name || 'Receta guardada',
                  items: recipe.items || [],
                  imageUrl: recipe.imageUrl,
                  tags: recipe.tags || [],
                  isCustom: recipe.custom || false
                };

                if (dayEntry) {
                  dayEntry.recipes.push(recipeObj);
                } else {
                  newWeekPlan.push({
                    day: entry.date,
                    type: entry.type,
                    recipes: [recipeObj]
                  });
                }
              });
            }
          });
        }

        this.weekPlan = JSON.parse(JSON.stringify(newWeekPlan));
        this.originalWeekPlan = JSON.parse(JSON.stringify(newWeekPlan));
        this.templateName = template.name || '';
        this.templateDescription = template.description || '';

      } catch (error) {
        console.error(this.$t('health.nutritionalPlanTemplate.errorRecipes'), error);
      }
    },
    totalMacro(items, macro) {
      return items.reduce((sum, item) => sum + (item[macro] || 0), 0).toFixed(1);
    },
    summaryTotalKcals() {
      if (!this.selectedDaySummary || !this.selectedDaySummary.items) return 0;
      return parseFloat(this.totalMacro(this.selectedDaySummary.items, 'calories'));
    },
    summaryProteinPercent() {
      const kcals = this.summaryTotalKcals();
      if (!kcals) return 0;
      return ((parseFloat(this.totalMacro(this.selectedDaySummary.items, 'protein')) * 4 / kcals) * 100).toFixed(2);
    },
    summaryCarbsPercent() {
      const kcals = this.summaryTotalKcals();
      if (!kcals) return 0;
      return ((parseFloat(this.totalMacro(this.selectedDaySummary.items, 'carbs')) * 4 / kcals) * 100).toFixed(2);
    },
    summaryFatPercent() {
      const kcals = this.summaryTotalKcals();
      if (!kcals) return 0;
      return ((parseFloat(this.totalMacro(this.selectedDaySummary.items, 'fat')) * 9 / kcals) * 100).toFixed(2);
    },
    selectDay(day) {
      if (this.selectedDaySummary && this.selectedDaySummary.day === day) {
        this.selectedDaySummary = null;
        this.showSummary = false;
        return;
      }

      const allItems = [];
      const byMealType = {};

      this.mealTypes.forEach(mealType => {
        const meal = this.getMealsByDayAndType(day, mealType)[0];
        const items = meal ? meal.items : [];
        allItems.push(...items);
        byMealType[mealType] = items;
      });

      this.selectedDaySummary = { day, items: allItems, byMealType };
      this.showSummary = true;
    },
    openAddFoodModal() {
      if (!this.addFoodDay || !this.addFoodMealType) {
        alert(this.$t('health.nutritionalPlan.selectDayAndMealType'));
        return;
      }

      const dayPlan = this.weekPlan.find(d => d.day === this.addFoodDay && d.type === this.addFoodMealType);
      if (!dayPlan){
        alert(this.$t('health.nutritionalPlan.noLooseFood'));
        return;
      }
      this.showAddFoodModal = true;
    },

    async onFoodSelected(foods) {
      const foodList = Array.isArray(foods) ? foods : [foods];
      if (foodList.length === 0) return;
      const dayPlan = this.weekPlan.find(d => d.day === this.addFoodDay && d.type === this.addFoodMealType);
      if (!dayPlan || !dayPlan.recipes[0]) return;

      const foodInfos = await Promise.all(
        foodList.map(f => foodApi.getFoodInfo(this, f.food_id, this.getLanguageCode))
      );

      foodList.forEach((food, idx) => {
        const foodInfo = foodInfos[idx];
        const newItem = {
          food_id: food.food_id,
          food_name: foodInfo.food_name,
          amount: foodInfo.portion,
          calories: foodInfo.energy_kJ_value ? parseFloat((foodInfo.energy_kJ_value / 4.184).toFixed(2)) : 0,
          protein: foodInfo.protein_grams_value || 0,
          carbs: foodInfo.carbohydrate_gram_value || 0,
          fat: foodInfo.fat_grams_value || 0,
          fibre: foodInfo.fibre_gram_value || 0
        };

        dayPlan.recipes[0].items.push(newItem);

        const key = `${this.addFoodDay}_${this.addFoodMealType}_${food.food_id}`;
        this.originalAmounts[key] = newItem.amount;
      });
    },

    onPlanSelected(plan) {
      if (!plan) return;

      const existingDayPlan = this.weekPlan.find(d => d.day === this.addFoodDay && d.type === this.addFoodMealType);

      const newRecipe = {
        id: plan.id,
        type: plan.type,
        name: plan.name,
        items: plan.items,
        imageUrl: plan.imageUrl,
        tags:plan.tags
      };

      if (existingDayPlan) {
        existingDayPlan.recipes.push(newRecipe);
      } else {
        this.weekPlan.push({
          day: this.addFoodDay,
          type: this.addFoodMealType,
          recipes: [newRecipe]
        });
      }
    },
    openRecipeDetail(meal, day, mealType) {
      const dayPlan = this.weekPlan.find(d => d.day === day && d.type === mealType);
      if (!dayPlan || !dayPlan.recipes[0]) return;

      this._editingDayPlan = dayPlan;

      const recipe = dayPlan.recipes[0];
      const originalEntry = this.originalWeekPlan
        ? this.originalWeekPlan.find(d => d.day === day && d.type === mealType)
        : null;

      const originalRecipe = originalEntry && originalEntry.recipes
        ? originalEntry.recipes.find(r => r.id === recipe.id)
        : null;

      const itemsChanged = !!originalRecipe &&
        this.areItemsChanged(recipe.items, originalRecipe.items);

      const isEdited = itemsChanged || recipe.isCustom || recipe.custom;

      this.selectedRecipe = {
        ...JSON.parse(JSON.stringify(recipe)),
        type: dayPlan.type,
        isEdited
      };
    },
    onRecipeModalClose(updatedItems) {
      if (this._editingDayPlan && updatedItems) {
        this._editingDayPlan.recipes[0].items = updatedItems;
      }
      this.selectedRecipe = null;
      this._editingDayPlan = null;
    },
    deleteRecipe(day, mealType) {
      const index = this.weekPlan.findIndex(d => d.day === day && d.type === mealType);
      if (index !== -1) {
        this.weekPlan.splice(index, 1);
      }
    },
    async changeRecipe(day, mealType) {
      const dayPlan = this.weekPlan.find(d => d.day === day && d.type === mealType);
      if (!dayPlan) return;
      const currentRecipeId = dayPlan.recipes && dayPlan.recipes.length > 0 ? dayPlan.recipes[0].id : null;
      try {
        const lang = this.getLanguageCode;
        console.log(lang);
        const record = await templateApi.getRandomRecipe(this, mealType, currentRecipeId, lang);

        if (record && record.recipes && record.recipes.length > 0) {
          const mappedRecipes = record.recipes.map(recipe => ({
            ...recipe,
            isCustom: recipe.isCustom || false,
            items: (recipe.items || []).map(item => ({
              ...item,
              food_name: item.food_name || item.foodName || item.name,
              name: item.name || item.foodName || item.food_name,
              food_id: item.food_id || item.foodId,
              amount: parseFloat(Number(item.amount || 0).toFixed(2)),
              calories: parseFloat(Number(item.calories || 0).toFixed(2)),
              protein: parseFloat(Number(item.protein || 0).toFixed(2)),
              carbs: parseFloat(Number(item.carbs || 0).toFixed(2)),
              fat: parseFloat(Number(item.fat || 0).toFixed(2)),
              fibre: parseFloat(Number(item.fibre || 0).toFixed(2))
            }))
          }));
          this.$set(dayPlan, 'recipes', mappedRecipes);
        }
      } catch (error) {
        console.error(this.$t('health.nutritionalPlanTemplate.errorChangeRecipe'), error);
      }
    },
    openSearchRecipeModal() {
      if (!this.addFoodDay || !this.addFoodMealType) {
        alert(this.$t('health.nutritionalPlan.selectDayAndMealType'));
        return;
      }

      const existingRecipe = this.weekPlan.find(
        d => d.day === this.addFoodDay && d.type === this.addFoodMealType && d.recipes && d.recipes.length > 0
      );

      if (existingRecipe) {
        const confirmReplace = confirm(
          this.$t('health.nutritionalPlan.recipeAlreadyAssigned')
        );
        if (!confirmReplace) return;
        this.deleteRecipe(this.addFoodDay, this.addFoodMealType);
      }
      this.showSearchRecipeModal = true;
    },
    mealTypeProteinPercent(items) {
      const kcals = parseFloat(this.totalMacro(items, 'calories'));
      if (!kcals) return 0;
      return ((parseFloat(this.totalMacro(items, 'protein')) * 4 / kcals) * 100).toFixed(2);
    },
    mealTypeCarbsPercent(items) {
      const kcals = parseFloat(this.totalMacro(items, 'calories'));
      if (!kcals) return 0;
      return ((parseFloat(this.totalMacro(items, 'carbs')) * 4 / kcals) * 100).toFixed(2);
    },
    mealTypeFatPercent(items) {
      const kcals = parseFloat(this.totalMacro(items, 'calories'));
      if (!kcals) return 0;
      return((parseFloat(this.totalMacro(items, 'fat')) * 9 / kcals) * 100).toFixed(2);
    },
    async updatePlan() {
      try {
        const flatRecipes = [];
        this.weekPlan.forEach(dayPlan => {
          if (dayPlan.recipes && dayPlan.recipes.length > 0) {
            const originalEntry = this.originalWeekPlan.find(d => d.day === dayPlan.day && d.type === dayPlan.type);
            dayPlan.recipes.forEach(recipe => {
              const originalRecipe = originalEntry && originalEntry.recipes
                ? originalEntry.recipes.find(r => r.id === recipe.id)
                : null;
              const itemsChanged = !!originalRecipe &&
                this.areItemsChanged(recipe.items, originalRecipe.items);

              flatRecipes.push({
                recipeId: recipe.id,
                dayOfWeek: dayPlan.day,
                mealType: dayPlan.type,
                isCustom: itemsChanged || recipe.isCustom || recipe.custom,
                isNew: itemsChanged,
                name: recipe.name,
                items: (recipe.items || []).filter(item => item != null).map(item => ({
                  food_id: item.food_id || item.foodId,
                  food_name: item.food_name || item.foodName,
                  amount: item.amount,
                  calories: item.calories,
                  protein: item.protein,
                  fat: item.fat,
                  carbs: item.carbs,
                  fibre: item.fibre
                }))
              });
            });
          }
        });

        const payload = {
          name: this.templateName,
          description: this.templateDescription,
          recipes: flatRecipes
        };

        const templateId = this.$route.query.templateId;

        if (templateId) {
          await templateApi.updateTemplate(this, templateId, payload);
        } else {
          const created = await templateApi.createTemplate(this, payload);
          this.$router.replace({
            name: 'EditTemplate',
            query: { templateId: created.id }
          });
        }

        alert(this.$t('health.nutritionalPlanTemplate.confirmSave'));

      } catch (error) {
        console.error(error);
      }
    },
    areItemsChanged(currentItems = [], originalItems = []) {
      if (currentItems.length !== originalItems.length) return true;
      for (const current of currentItems) {
        const currentId = current.food_id || current.foodId;
        const currentAmount = parseFloat(Number(current.amount || 0).toFixed(2));
        const original = originalItems.find(orig => (orig.food_id || orig.foodId) === currentId);
        if (!original) return true;
        const originalAmount = parseFloat(Number(original.amount || 0).toFixed(2));
        if (currentAmount !== originalAmount) return true;
      }
      return false;
    }

  }
};
</script>

<style lang="scss" scoped>
@import "../../../../stylesheets/variables";

$accent: #F35647;

.week-table-wrapper {
  overflow-x: auto;
}

.week-table {
  width: 250px;
  height: 250px;
  border-collapse: collapse;
  table-layout: fixed;
}

.week-table th,
.week-table td {
  border: 1px solid $black-light9;
  vertical-align: top;
  padding: 10px;
}

.week-table th {
  background: $disabled;
  text-transform: capitalize;
}

.meal-type {
  font-weight: 600;
  width: 120px;
}

.save-button-wrapper {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 16px;
}
.week-table {
  width: 100%;
  table-layout: fixed;
  border-collapse: collapse;
}

.week-table td,
.week-table th {
  vertical-align: top;
  padding: 0.5em;
}
.week-table td:first-child,
.week-table th:first-child {
  width: 8%;
  white-space: nowrap;
  padding-right: 1em;
}

.meal-image {
  width: 100%;
  aspect-ratio: 16/9;
  object-fit: cover;
  border-radius: 0.5em;
  display: block;
  margin-bottom: 0.5em;
}
.meal-image--placeholder {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: $black-light9;
  font-size: 2.5em;
  color: $black-light6;
}

.meal-name {
  font-weight: bold;
  font-size: 0.85em;
  margin: 0 0 0.5em 0;
}
.macros {
  display: flex;
  flex-wrap: wrap;
  gap: 0.25em;
  margin-top: 0.5em;
  font-size: 0.8em;
}

.macros span {
  background: $black-light9;
  border-radius: 12px;
  padding: 2px 8px;
}
.week-table td {
  height: 200px;
  vertical-align: top;
  overflow-y: auto;
}
.calendar-layout {
  display: flex;
  flex-direction: row;
  gap: 1em;
  align-items: flex-start;
}
.macro-summary--inline {
  margin-top: 0.5em;
  font-size: 0.8em;

  .macro-summary__percent {
    font-size: 0.75em;
    padding: 0.1em 0.4em;
  }
}
.week-table {
  flex: 1;
  min-width: 0;
}

.calendar-layout {
  display: flex;
  flex-direction: row;
  gap: 1em;
  align-items: flex-start;
}

.week-table {
  flex: 1;
  min-width: 0;
}

.week-table th.selected-day {
  background-color: $accent;
  color: $white;
}


.summary-panel {
  width: 220px;
  flex-shrink: 0;
  border: 1px solid rgba($black-trans6, 0.25);
  border-radius: 4px;
  padding: 1em;
  position: sticky;
  top: 1em;
}

.summary-title {
  color: $accent;
  font-weight: bold;
  margin: 0 0 1em 0;
  font-size: 1.2em;
}

.add-food-section {
  margin-top: 1em;
  padding: 1em;
  border: 1px solid rgba($black-trans6, 0.25);
  border-radius:$radius;
}

.add-food-selects {
  display: flex;
  gap: 1em;
  align-items: center;

  select {
    padding: 0.5em;
    border-radius:$radius;
    border: 1px solid rgba($black, 0.25);
  }
}

.add-food-btn {
  background-color: $accent;
  color: $white;
  border: none;
  border-radius: $radius;
  padding: 0.5em 1em;
  cursor: pointer;

  &:hover {
    background-color: #F46355;
  }
}
.meal-actions {
  display: flex;
  gap: 0.5em;
  justify-content: flex-end;
  margin-top: auto;
  padding-top: 0.5em;
}
.update-plan-btn {
  background-color: $accent;
  color: $white;
  border: none;
  border-radius: 4px;
  padding: 0.5em 1em;
  cursor: pointer;

  &:hover {
    background-color: darken($accent, 10%);
  }
}


.form-input,
.form-textarea {
  flex: 0 1 1500px;
  width: 100%;
  padding: 0.5em;
  border-radius: 4px;
  border: 1px solid rgba($black, 0.25);
}

.form-textarea {
  min-height: 80px;
  resize: vertical;
}


.form-row {
  display: flex;
  align-items: flex-start;
  gap: 2rem;
  margin-bottom: 1em;
}

.form-label {
  width: 120px;
  flex-shrink: 0;
  font-weight: 600;
  padding-top: 0.5em;
}

.required {
  color: $accent;
}
</style>




// WEBPACK FOOTER //
// src/brand/health/layouts/nutritionalPlan/EditTemplate.vue